import { Pages } from 'interfaces/main';
import React from 'react';
import { Route, RouteComponentProps, useHistory } from 'react-router-dom';
import LoaderFullScreen from 'components/LoaderFullScreen';
import { auth_loader, auth_hasJwtToken } from 'store/auth/selectors';
import { user_loader, user_userInfo } from 'store/user/selectors';
import { connect } from 'react-redux';
import { checkUserDataComplete } from 'helpers/checkUserDataComplete';
import ToHomePage from './ToHomePage';
import { AccountInfoParsed } from 'services/generatedClientFromSwagger';

export interface UserDataCompletionRouteProps {
    component: React.ComponentType<RouteComponentProps>;
    hasJwtToken: boolean;
    loginLoading: boolean;
    userLoader: boolean;
    userInfo: AccountInfoParsed;
}

const UserDataCompletionRoute: React.FunctionComponent<UserDataCompletionRouteProps> = (props) => {
    const { component: Component, hasJwtToken, loginLoading, userLoader, userInfo, ...restProps } = props;

    let history = useHistory();

    if (!hasJwtToken && !loginLoading) {
        history.replace(`/${Pages.LOGIN}`);
        return null;
    }

    if (loginLoading || userLoader) {
        return <LoaderFullScreen />;
    }

    if (userInfo) {
        const { isComplete: isUserDataComplete } = checkUserDataComplete(userInfo);
        if (isUserDataComplete) {
            return <ToHomePage />;
        }
    }

    return <Route {...restProps} render={(props) => <Component {...props} />} />;
};

export const mapStateToProps = (state) => ({
    hasJwtToken: auth_hasJwtToken(state),
    loginLoading: auth_loader(state),
    userLoader: user_loader(state),
    userInfo: user_userInfo(state),
});

export const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(UserDataCompletionRoute));
